import React from 'react';
import {AccountTier, AccountTierLabels} from '../../../shared/scoredAccounts';
import {keys} from '../../../shared/util';
import {FilterControlWithNegate} from './FilterControlWithNegate';
import {FilterSelect} from './FilterSelect';

const tierOptions = keys(AccountTierLabels).map((value) => ({
  value,
  label: AccountTierLabels[value],
}));

export const FitTierFilterControl = ({
  value,
  negate,
  onChange,
  onRemove,
}: {
  value: AccountTier[];
  negate?: boolean;
  onChange: (value: AccountTier[], negate?: boolean) => void;
  onRemove: () => void;
}) => {
  const selectedTierOptions = value.map((v) => ({
    value: v,
    label: AccountTierLabels[v],
  }));

  return (
    <FilterControlWithNegate
      value={value}
      negate={negate}
      onChange={onChange}
      onRemove={onRemove}
    >
      {(_, onValueChange) => (
        <FilterSelect
          options={tierOptions}
          isMulti
          onChange={(values) => {
            onValueChange(values.map((v) => v.value) as AccountTier[]);
          }}
          value={selectedTierOptions}
        />
      )}
    </FilterControlWithNegate>
  );
};
